import { api, danger, routeToUrl, success, swalOtp, useAuthStore } from "@";
import { getNewProfileInfo } from "./helpers";
import Swal from "sweetalert2";

const phoneNumber = localStorage.getItem("phoneNumber");
const token = localStorage.getItem("token");

// Login API call
export const login = (data) => api.post("/api/adminauth/auth/login", data);

// Forgot password API call
export const forgotPassword = ({ phoneNumber }) =>
  api.post("/api/adminauth/auth/reset-password", { phoneNumber });

// Check OTP match API call
export const checkOtpMatch = async (otpValue) => {
  if (!otpValue) {
    await danger("الرجاء ادخال رمز التحقق");
    return;
  }

  const payload = { otpValue, phoneNumber };

  try {
    const { data: res } = await api.post(
      "/api/adminauth/auth/check-otp",
      payload,
    );
    await success("رمز التحقق صحيح, سوف يتم توجيهك لصفحة تعيين كلمة المرور");
    localStorage.setItem("token", res.token);
    routeToUrl("/reset-password");
  } catch (error) {}
};

// Resend OTP API call
export const resendOtp = async () => {
  console.log("phoneNumber", phoneNumber);
  try {
    if (!phoneNumber) {
      routeToUrl("/forget-password");
    }
    await forgotPassword({phoneNumber});
    await success("تم ارسال رمز التحقق");
  } catch (error) {
    await danger("حدث خطأ, الرجاء المحاولة مرة اخرى");
  }
};

// Reset password API call
export const resetPassword = async (data) => {
  const payload = { newPassword: data.newPassword };
  return await api.put(`/api/AdminAuth/auth/change-password`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Update profile with OTP validation
export const updateProfileOTP = async () => {
  let isValidOTP = false;
  const { user, setUser } = useAuthStore.getState();

  while (!isValidOTP) {
    const { value: otpValue } = await swalOtp();

    if (!otpValue) return;

    const payload = {
      otp: otpValue,
      phoneNumber: getNewProfileInfo().phoneNumber,
    };

    try {
      await api.put(`/api/AdminUser/${user?.id}/validate-otp-update`, payload);
      await success("رمز التحقق صحيح, تم تحديث البيانات بنجاح");

      let profile = getNewProfileInfo();
      const { id, token, cartId, userPermissions, validTo } = user;
      const updatedUser = {
        ...profile,
        id,
        token,
        cartId,
        validTo,
        userPermissions,
      };
      setUser(updatedUser);
      localStorage.removeItem("profile");
      routeToUrl("/profile");

      isValidOTP = true;
    } catch (error) {
      await Swal.fire({
        toast: true,
        timer: 2000,
        icon: "error",
        type: "error",
        position: "top",
        showCancelButton: false,
        showConfirmButton: false,
        title: "رمز التحقق غير صحيح",
      });
    }
  }
};

// Save profile information and request OTP for update
export const saveProfileInfo = async (form) => {
  const payload = {
    email: form.email,
    password: form.password,
    displayName: form.displayName,
    phoneNumber: form.phoneNumber,
  };
  return api.put(`/api/AdminUser/${form.id}/request-otp-update`, payload);
};
